import { Component } from 'react'
import { Config } from '../config/IISMethods'
import htmltags from "../assets/JSON/blacklisttags.json"
import htmllisteners from "../assets/JSON/blacklistlistener.json"

export default class JsCall extends Component {

    //All Right Sidebar Code Start

    handleRightSidebar() {
        document.getElementById('rightSidebar').classList.toggle('active-right-sidebar')
        document.body.classList.toggle('overflow-hidden')
        document.querySelector("[class~='full-overlay']").classList.toggle('show')
    }

    //All Right Sidebar Code End

    //All Filter Right Sidebar Code Start

    handleFilterRightSidebar() {
        document.getElementById('filterrightSidebar').classList.toggle('active-right-sidebar')
        document.body.classList.toggle('overflow-hidden')
        document.querySelector("[class~='full-overlay']").classList.toggle('show')
    }

    //for edit menudesign in sidebar
    handleEditMenuDesignRightSidebar() {
        try {
            document.getElementById('editmenudesignsidebar').classList.toggle('active-left-sidebar')
            document.body.classList.toggle('overflow-hidden')
            document.querySelector("[class~='full-overlay-editsidebar']").classList.toggle('show')

        }
        catch (e) {
            // console.log(e)
        }
    }

    //All Filter Right Sidebar Code End

    //All GridMenu Code Start

    handleGridMenu() {
        // if(flag) {
        //     document.getElementById('tblDropdownContent').classList.remove('active')
        //     document.querySelector("[class~='grid-dropdown-overlay-bg']").classList.remove('show')
        // }
        // else {
        //     document.getElementById('tblDropdownContent').classList.add('active')
        //     document.querySelector("[class~='grid-dropdown-overlay-bg']").classList.add('show')
        // }
        try {
            document.getElementById('tblDropdownContent').classList.toggle('active')
            document.querySelector("[class~='grid-dropdown-overlay-bg']").classList.toggle('show')
        } catch (error) {
            console.log(error)

        }
    }

    //All GridMenu Code End

    handleSort(fieldObj) {
        const element = document.querySelector(`[class~=${fieldObj.tblsize}][name=${fieldObj.field}]`)
        element.classList.toggle('sorting_asc')
        element.classList.toggle('sorting_desc')
    }

    // used for tab switching logic in form
    /**
     * 
     * @param {String,Event Object} e - current clicked tab's event
     * @param {String} prevtabid - prev selected tab's id
     */
    handleRightSidebarTab(e, prevtabid) {
        var tabname
        if (typeof (e) === 'string') {
            tabname = e
        }
        else {
            e?.preventDefault()
            tabname = e?.target.id
        }

        // previous active remove class
        var element = prevtabid?.length ? document.getElementById(prevtabid) : document.querySelector("[class='tabs_links active']")
        element.classList.remove('active')

        // make current selected active
        element = document.getElementById(tabname)
        element.classList.add('active')

        element = prevtabid?.length ? document.getElementById(prevtabid + '-tab') : document.querySelector("[class='tab-pane fade active show']")
        element.classList.remove('active')
        element.classList.remove('show')

        element = document.getElementById(tabname + '-tab')
        element.classList.add('active')
        element.classList.add('show')
    }
    // used for tab switching logic in form


    // close drop down item menu of rsuite
    /**
     * 
     * @param {Event Object} e - js event 
     */
    handleCloseDropdown(e) {
        var element = e.currentTarget

        if (!element) { // If undefined then return | Utsav Sutariya 19/12/24
            return;
        }

        element = element?.parentNode // If no parent node then return | Utsav Sutariya 19/12/24
        if (!element) {
            return;
        }

        // hemang jani 17/2/23
        if (element.hasAttribute("role")) {
            element.setAttributeNode(document.createAttribute("hidden"));
        } else {
            while (element && !element.hasAttribute("role")) {
                element = element?.parentNode;
                if (!element) {
                    return;
                }
            }
            if (element) { // Check element after the loop
                element.setAttributeNode(document.createAttribute("hidden"));
            } else {
                return;
            }
        }

        element = element?.parentNode
        element.classList.remove('rs-dropdown-open')

        element = element?.childNodes[0]
        element.removeAttribute('area-expanded')
    }


    // not in use 
    handleHasVal(id, value) {
        var element = document.getElementById(id)
        try {
            while (!element.classList.contains('form-control')) {
                element = element.parentNode
            }
        }
        catch {
            if (id === 'form-contact') {
                element = document.getElementById(id)
                element = element?.childNodes[0]
                element = element?.childNodes[0]
            }
        }

        try {
            if (value) {
                element?.classList.add('has-val')
            }
            else {
                element?.classList.remove('has-val')
            }
        }
        catch (e) {
            console.log(e)
        }
    }
    // not in use 

    /**
     * used while validation to add / remove red border on html input 
     * @param {String} id
     * @param {boolean} hasError - to add or remove validation class / red border
     * @param {String} type - field type of data (come in consideration to add danger class on table validation )
     */
    handleError(id, hasError, type) {
        var element = document.getElementById(id);
        try {
            while (!element.classList.contains('form-group')) {
                element = element.parentNode
            }
        }
        catch {
            try {
                if (id === 'form-contact') {
                    element = document.getElementById(id)
                    element = element.childNodes[0]
                    element = element.childNodes[0]
                }
            }
            catch (e) {
                console.log(e)
            }
        }

        try {
            if (hasError) {
                element?.classList?.add('error')
                if (type === 'table') {
                    try {
                        let tableEle = document.getElementById(id)
                        tableEle?.classList.add('border-danger-common')

                        setTimeout(() => {
                            tableEle?.classList.remove('border-danger-common')
                        }, 2000);
                    }
                    catch (e) {
                        console.log(e)
                    }
                }
            }
            else {
                element?.classList?.remove('error')
            }
        }
        catch (e) {
            console.log(e)
        }
    }

    /**
     * to get object using field name from JSON 
     * @param {Array} formData - JSON Array
     * @param {String} field - field name 
     * @returns {Object} 
     */
    getobjectfromformdata(formData, field) {
        var object = {}
        Array.isArray(formData) && formData?.map((data) => !Object.keys(object)?.length ? object = data.formfields?.find(o => o.field === field) || {} : object = object)
        return object
    }

    //create regex from user defined HTML tags in all sentences 
    createHtmlTagRegex(tagName) {
        // Escape special characters in the tag name
        const escapedTagName = tagName.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
        // Create a regex pattern to match the opening and closing tags
        const regexPattern = new RegExp(`<${escapedTagName}[^>]*>[\\s\\S]*?<\\/${escapedTagName}>`, 'gi');
        return regexPattern;
    }

    //create regex from user defined word in all sentences 
    createRegexPattern(userDefinedWord) {
        // Escape user-defined word to handle special characters in regex
        const escapedUserDefinedWord = userDefinedWord.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
        // Create a regex pattern that matches the user-defined word surrounded by word boundaries
        const regexPattern = new RegExp('\\b' + escapedUserDefinedWord + '\\b', 'gi');
        return regexPattern;
    }

    //validate script, a, Link, .exe tag 
    validateTags(value) {
        let isHasError = false;
        if (value) {
            isHasError = htmltags?.some((tags) => this.createHtmlTagRegex(tags).test(value))
            if (isHasError === false) {
                isHasError = htmllisteners?.some((listener) => this.createRegexPattern(listener).test(value))
            }
        }
        return isHasError
    }

    // validateTags(value) {
    //     let errorDetails = {
    //         hasError: false,
    //         errors: [] // Array to store multiple errors
    //     };

    //     if (value) {
    //         // Check HTML tags and capture ALL matches
    //         htmltags?.forEach((tag) => {
    //             const regex = this.createHtmlTagRegex(tag);
    //             const matches = [...value.matchAll(regex)]; // Get all matches

    //             matches.forEach((match) => {
    //                 errorDetails.errors.push({
    //                     errorType: 'HTML Tag',
    //                     restrictedWord: tag,
    //                     matchedText: match[0],
    //                     position: match.index,
    //                     errorMessage: `HTML tag "${tag}" is not allowed`
    //                 });
    //             });
    //         });

    //         // Check HTML listeners/attributes and capture ALL matches
    //         htmllisteners?.forEach((listener) => {
    //             const regex = this.createRegexPattern(listener);
    //             const matches = [...value.matchAll(regex)]; // Get all matches

    //             matches.forEach((match) => {
    //                 errorDetails.errors.push({
    //                     errorType: 'HTML Listener/Attribute',
    //                     restrictedWord: listener,
    //                     matchedText: match[0],
    //                     position: match.index,
    //                     errorMessage: `HTML attribute "${listener}" is not allowed`
    //                 });
    //             });
    //         });

    //         // Additional security patterns check
    //         const securityPatterns = [
    //             { pattern: /on\w+\s*=/gi, type: 'Event Handler', name: 'Event Handlers (onclick, onchange, etc.)' },
    //             { pattern: /javascript:/gi, type: 'JavaScript Protocol', name: 'javascript:' },
    //             { pattern: /<script[^>]*>/gi, type: 'Script Tag', name: '<script>' },
    //             { pattern: /eval\s*\(/gi, type: 'JavaScript Function', name: 'eval()' },
    //             { pattern: /expression\s*\(/gi, type: 'CSS Expression', name: 'expression()' }
    //         ];

    //         securityPatterns.forEach((patternObj) => {
    //             const matches = [...value.matchAll(patternObj.pattern)];
    //             matches.forEach((match) => {
    //                 errorDetails.errors.push({
    //                     errorType: patternObj.type,
    //                     restrictedWord: patternObj.name,
    //                     matchedText: match[0],
    //                     position: match.index,
    //                     errorMessage: `${patternObj.type} "${match[0]}" is not allowed`
    //                 });
    //             });
    //         });

    //         errorDetails.hasError = errorDetails.errors.length > 0;
    //     }

    //     return errorDetails;
    // }



    /**
     * Validates Form 
     * @param {object} formData - formdata object of form
     * @param {array} validations - json of form
     * @param {string} key - to validate one filed at a time
     * @param {formname} formname - prefix used in id of field
     * @param {boolean} showerror - show error in form or not
     * @param {boolean} tabsinview - when view file have a tab type structure at that time we dont need to call handlerightsidebartab function
     * @param {boolean} fieldinview - when field is not in view and you have to return true if there is any error --> set false
     * @returns {boolean} haserror - true for error and false for no error
     */
    validateForm(formData, validations, key, formname, showerror = true, tabsinview = false, fieldinview = true) {
        var hasError
        // used when validating one input at a time
        if (key) {
            var value = formData[key]
            validations = this.getobjectfromformdata(validations, key)
            if (validations.type === 'input-text' || validations.type === 'number-input' || validations.type === 'radio' || validations.type === 'password' || validations.type === 'input-textarea' || validations.type === 'contact-number' || validations.type === 'float-number-input') {

                try {
                    value = value.toString()
                    hasError = !value.match(new RegExp(validations.regex))
                        || parseFloat(value) < validations.minvalue
                        || parseFloat(value) > validations.maxvalue
                        || value?.length < validations.minlength
                        || value?.length > validations.maxlength
                        || parseFloat(value) <= parseFloat(formData[validations.shouldgreaterthan])
                }
                catch (e) {
                    hasError = true
                }
            }
            else if (validations.type === 'intltelinput') {
                try {
                    // Step 1: Remove invisible WhatsApp chars and spaces (including normal spaces and NBSPs)
                    let sanitizedValue = value?.toString().replace(/[\u200E\u200F\u202A-\u202E]/g, '') // remove invisible chars
            
                    // Step 2: Validate strictly digits only (7-15 digits)
                    const regex = /^\d{6,14}$/;
            
                    hasError = !regex.test(sanitizedValue)
                        || sanitizedValue.length < validations.minlength
                        || sanitizedValue.length > validations.maxlength;
                } catch (e) {
                    hasError = true;
                }
            }
            
            else if (validations.type === 'dropdown') {
                try {
                    // for check dummy id
                    // value = (value === Config.dummyid || !value) ? '' : value
                    value = (value === Config.dummyid || value == null || value == undefined) ? '' : value
                    if (value == 0) {
                        hasError = false
                    } else {
                        hasError = !value
                        hasError ||= (!value && validations.required)
                        hasError &&= (value || validations.required)
                    }
                    // hasError = !value
                    // hasError ||= (!value && validations.required)
                    // hasError &&= (value || validations.required)
                }
                catch {
                    hasError = true
                }
            }
            else if (validations.type === 'table' || validations.type === 'multipleselectdropdown' || validations.type === 'daterangepicker' || validations.type === 'timerangepicker' || validations.type === 'checkpicker') {
                try {
                    hasError = !value?.length
                    hasError ||= (!value?.length && validations.required)
                    hasError &&= (value?.length || validations.required)
                }
                catch (e) {
                    console.log(e)
                    hasError = validations.required
                }
            }
            else if (validations.type === 'html-editor') {
                // remove new lines 
                value = value?.replaceAll('<p><br></p>', '')
                // remove spaces
                value = value?.replaceAll(/<p>\s*<\/p>/g, '')
                hasError = !value?.length
            }
            else if (validations.type === 'suneditor-html') {
                // check if any data in html tags
                //checks between open and close tag if data or not : ex:-<h1></h1> returns false
                let regex = /(<([^>]+)>)/ig
                let zero_width_charecter = /[\u200B-\u200D\uFEFF]/g
                // used when only image or video uploaded in data
                let imge_video_src = /[^>]*src="[^"]*"[^>]*>/gm
                let srcuploaded = value.match(imge_video_src) || []
                if (srcuploaded?.length) {
                    hasError = false
                }
                else {
                    value = value.replace(zero_width_charecter, '')
                    value = !!value.replace(regex, "")?.length
                    hasError = !value
                }
            }
            else {
                hasError = false
            }
            // hasError ||= (value == '' && value == null && value == undefined && isNaN(value) && validations.required)
            hasError ||= ((value === '' || value == null || value == undefined) && validations.required)
            // hasError ||= (value == '' && validations.required)
            // hasError ||= (!value && validations.required)
            hasError &&= (value || validations.required)
            if (document.getElementById((formname ? formname : 'form') + '-' + key) || !fieldinview) {
                if (showerror)
                    this.handleError((formname ? formname : 'form') + '-' + key, hasError, validations.type)
            }
            else {
                hasError = false
            }
            if (hasError) {
            }
            return hasError
        }
        else {
            var hasError = false

            var view
            // used when validating all inputs of form
            validations?.map((data) =>
                data.formfields?.filter(formfield => !formfield.istablefield)?.map((fields) => {
                    const tempHasError = this.validateForm(formData, validations, fields.field, formname, showerror)
                    hasError ||= tempHasError
                    if (tempHasError && !view)
                        view = data.tabname
                })
            )

            // for multiple tabs form , on validation error in given tab , open that tab automatically
            if (view && !tabsinview) {
                this.handleRightSidebarTab(view)
            }
            return hasError
        }
    }

    // JATIN 25/12/24 replace Tags for document genarate in recruitment Master 
    replaceTagsInContent(formData, fields) {
        try {
            let companystamp = (formData?.signature && formData?.stamp) ? `<div class="company-stamp autorised-sign"><img src='${formData.stamp ? formData.stamp : ''}'/></div>` : "";
            let companysignature = (formData?.signature && formData?.stamp) ? `<div class="company-signature autorised-sign"><img src='${formData.signature ? formData.signature : ''}'/></div>` : '';

            const replaceTags = {
                '#pagebreak?': "<div class='page-break-before'></div>",
                '#stamp?': formData?.hasphysicalsignature ? `<div class="h-150p"></div>` : formData?.stamp?.length > 0 ? `<img class="company-stamp autorised-sign" src='${formData?.stamp || ''}' />` : "#stamp?",
                '#signature?': formData?.hasphysicalsignature ? `<div class="h-150p"></div>` : formData?.signature?.length > 0 ? `<img class="only-signature autorised-sign" src='${formData?.signature || ''}'/>` : '#signature?',
                '#stampwithsignature?': formData?.hasphysicalsignature ? `<div class="h-150p"></div>` : (companysignature && companystamp) ? `<div class="signature-container">${companystamp} ${companysignature}</div>` : '#stampwithsignature?',
                '#employersignature?': (companysignature && companystamp) ? `<div class="signature-container">${companystamp} ${companysignature}</div>` : '#employersignature?',
                '#signpersondesignation?': formData?.designation?.length > 0 ? `${formData?.designation || ''}` : '#signpersondesignation?',
                '#signperson?': formData?.signperson?.length > 0 ? `${formData?.signperson || ''}` : '#signperson?',
            };

            // Start with the original content
            let replaceContent = formData[fields.field];


            // Iterate over the replace tags
            for (const [tag, replaceValue] of Object.entries(replaceTags)) {
                const escapedTag = tag.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
                const regex = new RegExp(escapedTag, 'g');

                // Perform replacement if the tag is found in the content
                if (regex.test(replaceContent)) {
                    replaceContent = replaceContent.replace(regex, replaceValue);
                }
            }

            return replaceContent;
        } catch (error) {
            console.error("Error replacing tags in content:", error);
        }
    };

    // JATIN 14/02/2024 Check HTML editor Content Empty one line with Space Consider as empty with multiple line with space  consider as content 
    checkEditorEmpty(html) {
        try {
            if (typeof html !== "string") {
                return true;
            }
            let cleanedHtml = html.replace(/<p>(\s|&nbsp;)*<\/p>/gi, '').trim();

            const brParagraphs = (html.match(/<p>\s*<br\s*\/?>\s*<\/p>/gi) || [])?.length;

            return cleanedHtml?.length === 0 || (cleanedHtml === "<p><br></p>" && brParagraphs === 1);
        } catch (error) {
            return true; // In case of an error, assume content is empty
        }
    };

    // replace the iframe tag to video tag | JATIN 25/03/2025
    replaceIframeWithVideo = (html, maxw = "100%", maxh = "700px") => {
        if (!html) return "";

        // Check if <p><br></p> exists and remove it only if present
        // temp commented by aman - causing issue when <br> tag is used intentionally
        if (html?.includes("<p><br></p>")) {
            html = html.replace(/<p><br><\/p>/gi, "");
        }
        return html?.replace(/<iframe([^>]*)>(.*?)<\/iframe>/gi, (match, p1, p2) => {
            return `<video${p1} controls  alt="video" style="transform: scaleX(1); max-width:${maxw}; max-height:${maxh}; object-fit: contain; height: auto; width: auto; display:block; margin: 0 auto;">${p2}</video>`;
        });
    };
}